import { gql } from '@apollo/client';
import { DEVICE_FIELDS, USER_FIELDS } from './fragments';

export const GET_USER = gql`
    ${USER_FIELDS}
    query getUserByToken {
        userByToken {
            ...UserFields
        }
    }
`;

export const SYNC_DEVICE_DATA = gql`
    ${DEVICE_FIELDS}
    query syncDeviceData($devices: [DeviceEnum], $memberId: String) {
        syncDeviceData(devices: $devices, memberId: $memberId) {
            ...DeviceFields
        }
    }
`;

export const REMOVE_DEVICE = gql`
    ${DEVICE_FIELDS}
    mutation removeDevice($memberId: String, $deviceId: String) {
        removeDevice(memberId: $memberId, deviceId: $deviceId) {
            ...DeviceFields
        }
    }
`;

export const UPDATE_USER_BY_MEMBER_ID = gql`
    ${USER_FIELDS}
    mutation UpdateUser($input: UpdateUserInput, $memberId: String) {
        updateUser(input: $input, memberId: $memberId) {
            ...UserFields
        }
    }
`;

export const ACCEPT_TERMS_AND_CONDITIONS = gql`
    ${USER_FIELDS}
    mutation AcceptTermsAndConditions($membersPortalEmail: String) {
        acceptTermsAndConditions(membersPortalEmail: $membersPortalEmail) {
            ...UserFields
        }
    }
`;

export const UPDATE_PASSWORD = gql`
    mutation UpdatePassword($input: UpdatePasswordInput) {
        updatePassword(input: $input) {
            membersPortalEmailAddress
        }
    }
`;

export const LOGOUT = gql`
    mutation Logout {
        logout
    }
`;
